import { z } from "zod";
// Calendar preference schemas and types
export const CallRuleSchema = z.enum(["all", "external", "internal", "manual"]);
// Mapping functions for calendar preferences
export function mapDbPreferenceToCallRule(dbPreference) {
    switch (dbPreference) {
        case "all":
            return "all";
        case "external_only":
            return "external";
        case "internal_only":
            return "internal";
        case "none":
            return "manual";
        default:
            return "manual";
    }
}
export function mapCallRuleToDbPreference(callRule) {
    switch (callRule) {
        case "all":
            return "all";
        case "external":
            return "external_only";
        case "internal":
            return "internal_only";
        case "manual":
            return "none";
        default:
            return "none";
    }
}
// API response schemas
export const CalendarPreferenceApiResponseSchema = z.object({
    preference: CallRuleSchema,
});
export const CalendarPreferenceErrorResponseSchema = z.object({
    error: z.string(),
});
export const CalendarPreferenceRequestBodySchema = z.object({
    preference: CallRuleSchema,
});
// Calendar sync result schema - for UI-facing sync operations (client-side)
export const CalendarSyncResultSchema = z.object({
    calendarId: z.string(),
    success: z.boolean(),
    message: z.string(),
    eventId: z.string().optional(),
    error: z.string().optional(),
});
// Bulk sync statistics schema - for server-side bulk operations (what calendarSyncService returns)
export const BulkSyncResultSchema = z.object({
    totalProcessed: z.number(),
    eventsUpdated: z.number(),
    eventsCreated: z.number(),
    callsUpdated: z.number(),
    deletedEvents: z.number(),
});
// Calendar provider types
export const CalendarProviderSchema = z.enum([
    "google_calendar",
    "microsoft_outlook",
]);
// Calendar connection schemas and types
export const CalendarConnectionSchema = z.object({
    provider: CalendarProviderSchema,
    refreshToken: z.string(),
    calendarId: z.string(),
    lastSyncedAt: z.string(),
    connectedAt: z.string().optional(),
});
export const CalendarConnectionsSchema = z.record(CalendarConnectionSchema);
